import { BaseFilterOption } from '../types';
import { CombinedInSilicoPrediction } from '../../components';

export const config: BaseFilterOption = {
  id: 'omicsExplorer.filters.combinedInSilicoPrediction',
  title: {
    id: 'omicsExplorer.filters.combinedInSilicoPrediction',
    defaultMessage: 'Combined In Silico Prediction',
  },
  content: CombinedInSilicoPrediction,
};
